import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ServicingCommonStoreService } from '@common/services';
import { SupportModalIdSubComponent } from '@lib/components/support-class';
import { StaticMsgPipe } from '@lib/pipes';
import { CommonLibService } from '@lib/services';
import { Subscription } from 'rxjs';
import { GetOrderResponseData, GetOrderResponseDataAir } from 'src/sdk-servicing';

@Component({
  selector: 'asw-lounge-service-request-header',
  templateUrl: './lounge-service-request-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoungeServiceRequestHeaderComponent extends SupportModalIdSubComponent {
  subscriptions = new Subscription();
  public cancelEvent: () => void = () => {};
  tooltipContent = '';

  constructor(
    private readonly _common: CommonLibService,
    private readonly _servicingCommonStoreService: ServicingCommonStoreService,
    private readonly _staticMsg: StaticMsgPipe,
    private readonly _cdr: ChangeDetectorRef
  ) {
    super(_common);
  }

  init() {
    this.subscriptions.add(
      this._servicingCommonStoreService.getServicingCommonModel$().subscribe((servicingCommon) => {
        const pnr: GetOrderResponseData = servicingCommon.getOrder ?? {};
        let tooltipContent = '';
        // サービシング共通store.PNR情報取得API応答.data.air.tripType="international"(国際旅程)の場合、"tooltip.paidLoungeint"とする。
        if (pnr.air?.tripType === GetOrderResponseDataAir.TripTypeEnum.International) {
          tooltipContent = this._staticMsg.transform('tooltip.paidLoungeint');
        }
        // サービシング共通store.PNR情報取得API応答.data.air.tripType="domestic"(日本国内単独旅程)の場合、"tooltip.paidLounge2"とする。
        if (pnr.air?.tripType === GetOrderResponseDataAir.TripTypeEnum.Domestic) {
          tooltipContent = this._staticMsg.transform('tooltip.paidLounge2');
        }
        this.tooltipContent = tooltipContent;
        this._cdr.markForCheck();
      })
    );
  }

  onClickCancel() {
    this.cancelEvent();
  }

  reload() {}
  destroy() {
    this.subscriptions.unsubscribe();
  }
}
